<template>
  <el-form-item :label="label" v-bind="$attrs">
    <el-input :value="value"
              v-on="listeners"
              v-bind="{type}"
              class="base-input"
              @input="onInput">
    </el-input>
  </el-form-item>
</template>

<script>
  export default {
    name: 'base-input',
    inheritAttrs: false,
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: [String, Number],
      label: String,
      type: String,
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.onInput
        }
      }
    },
    methods: {
      onInput(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
